import { stringToColor } from "@whatslly/commons/utils";
import classnames from "classnames";
import React from "react";
import styles from "./components.module.scss";

function getInitialsFromString(str: string) {
  if (!str) return "";

  const strParts = str.split(" ");
  if (strParts.length > 1) {
    return `${strParts[0]?.[0] ?? ""}${strParts[strParts.length - 1]?.[0] ?? ""}`.toUpperCase();
  }

  return str.substring(0, 2).toUpperCase();
}

export const ColoredName = React.forwardRef<
  HTMLDivElement,
  { name: string; loading?: boolean; className?: string; testId?: string; children?: React.ReactNode; onClick?: () => void }
>(({ name, loading, children, className, testId, onClick }, ref) => (
  <div
    style={{ backgroundColor: stringToColor(name) }}
    data-testid={testId}
    className={classnames(styles.colorAvatar, className)}
    onClick={onClick}
    ref={ref}
  >
    <span className={styles.letters}>{getInitialsFromString(name)}</span>
    {children}
    {loading && (
      <div className={styles.loader}>
        <span />
      </div>
    )}
  </div>
));
